import { RichTextDisplay, StatBar, type StatBarItem } from '@/components/shared';
import { useCollectibleContext } from '@/pages/collectibles/useCollectibleContext';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Skeleton,
} from '@startupquickstart/frontend';
import { Hash } from 'lucide-react';

/** Stock sentinel meaning "no cap". */
const UNLIMITED_STOCK = 0;

export function CollectibleOverviewTab() {
  const { collectible, isLoading } = useCollectibleContext();

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-32 rounded-xl" />
        <Skeleton className="h-48 rounded-xl" />
      </div>
    );
  }

  if (!collectible) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Collectible not found</p>
      </div>
    );
  }

  const stats: StatBarItem[] = [
    {
      label: 'Default Stock',
      value: collectible.defaultStock === UNLIMITED_STOCK ? 'Unlimited' : collectible.defaultStock,
      icon: Hash,
    },
  ];
  if (collectible.iconUrl) {
    stats.push({
      label: 'Icon',
      value: 'Set',
      leading: (
        <img
          src={collectible.iconUrl}
          alt={collectible.name}
          className="h-10 w-10 shrink-0 rounded-lg object-cover"
        />
      ),
    });
  }

  return (
    <div className="space-y-6">
      <StatBar items={stats} />

      {collectible.description && (
        <Card className="rounded-xl border bg-card shadow-sm py-0 gap-0">
          <CardHeader className="px-6 py-4 !pb-4 border-b">
            <CardTitle>Description</CardTitle>
            <CardDescription>Flavor text</CardDescription>
          </CardHeader>
          <CardContent className="p-6">
            <RichTextDisplay content={collectible.description} />
          </CardContent>
        </Card>
      )}

      {collectible.imageUrl && (
        <Card className="rounded-xl border bg-card shadow-sm py-0 gap-0">
          <CardHeader className="px-6 py-4 !pb-4 border-b">
            <CardTitle>Image</CardTitle>
            <CardDescription>Hero image</CardDescription>
          </CardHeader>
          <CardContent className="p-6">
            <img
              src={collectible.imageUrl}
              alt={collectible.name}
              className="rounded-lg max-h-48 object-cover"
            />
          </CardContent>
        </Card>
      )}
    </div>
  );
}
